import { useMemo } from "react";
import { BackendApiClient } from "../client/motalvip-apis/generated";

/**
 * Backend endpoint with no credentials, only for public endpoints.
 */
export const usePublicApiClient = () => {
  const client = useMemo(() => {
    return new BackendApiClient({
      BASE: process.env.REACT_APP_MOTAL_API_URL,
    });
  }, []);
  return { publicClient: client };
};
